import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchBusinessOptionsTypes = getApiActionTypes('FETCH_ATTACHMENTS_BUSINESS_OPTIONS');
export const fetchAttachmentDefinitionsTypes = getApiActionTypes('FETCH_ATTACHMENT_DEFINITIONS');
export const createAttachmentTypes = getApiActionTypes('CREATE_ATTACHMENT');
export const deleteAttachmentTypes = getApiActionTypes('DELETE_ATTACHMENT');
export const updateAttachmentTypes = getApiActionTypes('UPDATE_ATTACHMENT');
